import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import plus from "src/assets/icons/plusIcon.svg";
import { Card } from "react-bootstrap";

import { listGlobalDiagnosisTemplates } from "../prescription/api/index";
// import "../../patient.scss"
import "../prescription/prescription.scss";
import { debounce } from "lodash";
import { Input } from "@mobiscroll/react5";
import { addDiagnosisTemplate } from "./DiagnosisTab";
import Loader from "src/components/Dashboard/common/Loader";

const ListItem = ({ data, setLoader }) => {
  const { patientId } = useParams();
  // const { setLoader } = data;

  const addDiagnosis = () => {
    if (!patientId) return;
    let payLoad = {
      diagnosisName: data.diagnosisName,
      specialization: data.specialization.join(", "),
      clinicId: patientId,
    }

    setLoader(true);
    addDiagnosisTemplate(payLoad);
    setLoader(false);
  }

  return (
    <li className="list-item-select-vaccination" onClick={addDiagnosis}>
      <div className="mbsc-grid">
        <div className="mbsc-row">
          <div className="mbsc-col-5">
            <span>{data.diagnosisName}</span>
          </div>
          <div className="mbsc-col-5">{data.specialization.join(", ")}</div>
          <div className="mbsc-col-2 d-flex justify-content-end pr-0">
            <img style={{ height: "2em", width: "" }} src={plus} alt="" />
          </div>
        </div>
      </div>
    </li>
  );
};

const SelectDiagnosis = ({ img, title, placeholder }) => {
  const [search, setSearch] = React.useState("");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);

  const { patientId } = useParams();

  const listDiagnosis = async (search) => {
    try {
      setLoader(true);
      let res = await listGlobalDiagnosisTemplates(search);
      setData(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const debounceFn = useCallback(debounce(listDiagnosis, 1000), [search]);
  React.useEffect(() => {
    debounceFn(search);
  }, [search]);

  return (
    <>
      <Loader show={loader} />

      <Card className="docg-card w-100" style={{ flex: 1 }}>
        <Card.Title className="d-flex justify-content-between">
          {" "}
          <div className="d-flex">
            <img src={img} alt="" />
            <span>{title}</span>
          </div>
          <button onClick={() => listDiagnosis(search)} className="docg-save-btn">
            Refresh
          </button>
        </Card.Title>
        <Card.Body className="d-flex flex-column">
          {/* <input type="text" placeholder={placeholder} onChange={handleChange} value={select} /> */}
          <Input
            inputStyle="underline"
            labelStyle="floating"
            placeholder={placeholder}
            name="doctorName"
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            style={{ padding: "1em", }}
          />
          <div className="docg-select-list">
            <ul>
              {data?.map((item, i) => (
                <ListItem data={item} setLoader={setLoader} key={i} />
              ))}
            </ul>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default SelectDiagnosis;
